"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardGridWidget = void 0;
const HtmlWidget_1 = require("./HtmlWidget");
class CardGridWidget extends HtmlWidget_1.HtmlWidget {
    constructor() {
        super("div", "");
        this.renderBody.id = "card-div";
        this.renderBody.classList.add("card-grid");
    }
    addCard(cardName, cardBody, appendChild = false, cardClicked) {
        this.createElement("div", div => {
            div.classList.add("card", "card-grid-item");
            div.addEventListener("click", () => {
                if (cardClicked != null) {
                    cardClicked(div);
                }
            });
        }, appendChild)
            .createElement("div", div => div.classList.add("card-container"))
            .createElementAndAppend("h4", h4 => h4.textContent = cardName)
            .createElementAndAppend("p", (p) => p.textContent = cardBody);
    }
    shouldRender() {
        return true;
    }
}
exports.CardGridWidget = CardGridWidget;
//# sourceMappingURL=CardGridWidget.js.map